import { render, staticRenderFns } from "./GeoDistribution.vue?vue&type=template&id=1315828d&"
import script from "./GeoDistribution.vue?vue&type=script&lang=js&"
export * from "./GeoDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports